module.exports = __webpack_public_path__ + "img/01.55d68216.jpg";